import { CSSProperties } from 'react'

import styled, { css } from 'styled-components'

import { BuildPassTheme } from 'types/BuildPassTheme'

export type TextProps = {
  variant?: keyof BuildPassTheme['font']
  strong?: boolean
  stronger?: boolean
  block?: boolean
  primary?: keyof BuildPassTheme['colour']['primary']
  secondary?: keyof BuildPassTheme['colour']['secondary']
  semantic?: keyof BuildPassTheme['colour']['semantic']
  mt?: string
  mb?: string
  maxWidth?: string
  link?: boolean
  noVariant?: boolean
  align?: CSSProperties['textAlign']
  whitespace?: CSSProperties['whiteSpace']
}

export const Text = styled.span<TextProps>`
  ${({ theme, variant, noVariant }) =>
    noVariant ? '' : (theme.font[variant] ?? theme.font.body03)}

  ${({ strong }) =>
    strong &&
    css`
      font-weight: 500;
    `}


    ${({ stronger }) =>
    stronger &&
    css`
      font-weight: 600;
    `}


  ${({ block, mb, mt }) =>
    (block || mb || mt) &&
    css`
      display: block;
    `}

    /* Put link before primay and secondary so they can override the colour */
  ${({ link }) =>
    link &&
    css`
      color: ${({ theme }) => theme.colour.link.base};
      cursor: pointer;

      &:hover,
      &:focus {
        text-decoration: underline;
      }
    `}

  ${({ primary }) =>
    primary &&
    css`
      color: ${({ theme }) => theme.colour.primary[primary]};
    `}

  ${({ secondary }) =>
    secondary &&
    css`
      color: ${({ theme }) => theme.colour.secondary[secondary]};
    `}

  ${({ semantic }) =>
    semantic &&
    css`
      color: ${({ theme }) => theme.colour.semantic[semantic]};
    `}

  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${mb};
    `}

  ${({ mt }) =>
    mt &&
    css`
      margin-top: ${mt};
    `}

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `}

  ${({ align }) =>
    align &&
    css`
      text-align: ${align};
    `}
`

Text.displayName = 'Text'
